export enum DocumentMetadataType {
  amount_editable_currency = 'amount_editable_currency',
  amounts = 'amounts',
  amount = 'amount',
  date = 'date',
  'string' = 'string',
  datetime = 'datetime'
}
